import { create, devtools } from 'lib/zustand';
import type { NodeUser, Profile } from 'models';

export type User = {
  nodeUserData: NodeUser;
  railsUserData: Profile;
};

type UserAction = {
  reset: () => void;
  setUser: (user: User) => void;
};

type UserState = {
  user: null | User;
};

const initialState: UserState = {
  user: null,
};

const useUserStore = create<UserAction & UserState>()(
  devtools((set) => ({
    ...initialState,
    reset() {
      set(initialState);
    },
    setUser(user) {
      set({ user });
    },
  })),
);

export function useUser(options?: { requiredAuth?: true }): User;
export function useUser(options: { requiredAuth: false }): null | User;
export function useUser({ requiredAuth = true }: { requiredAuth?: boolean } = {}): null | User {
  const user = useUserStore((state) => state.user);

  if (!requiredAuth) {
    return user;
  }

  if (!user) {
    throw new Error('User was not found on a page that requires authentication');
  }

  return user;
}

export const useSetUser = () => useUserStore((state) => state.setUser);

export const getUserFromStore = () => useUserStore.getState().user;
